import React, {FC} from "react";
import { FallbackContainer } from "./styledComponents";

const EndToEndStepsFallback: FC = () => {
  return <FallbackContainer />;
};

export default EndToEndStepsFallback;
